document.addEventListener('Searchanise.Loaded', function () {
  (function ($) {
    if (window.innerWidth > 1024) {
      setTimeout(function () {
        const inputSuggestions = [
          'What are you looking for today?',
          'Brain Health',
          'Magnesium',
          'Heart Health',
          'Probiotic',
          'Zinc',
          'Digestive Health',
          'Candida',
          'Immune Health',
          'Calcium',
          'Stress and Sleep',
          'Quercetin',
          'Brain Health',
          'Magnesium',
          'Heart Health',
          'Probiotic',
          'Zinc',
          'Digestive Health',
          'Candida',
          'Immune Health',
          'Calcium',
          'Stress and Sleep',
          'Quercetin',
          'Brain Health',
          'Magnesium',
          'Heart Health',
          'Probiotic',
          'Zinc',
          'Digestive Health',
          'Candida',
          'Immune Health',
          'Calcium',
          'Stress and Sleep',
          'Quercetin'
        ];

        let index = 0;
        let firstIteration = true;

        function showSuggestion() {
          const item = inputSuggestions[index];

          $('.currentSuggestion').remove();

          if (index === 0 && firstIteration) {
            $('.snize-input-style').attr('placeholder', '');
            $('.snize-input-style').after(
              `<span class="currentSuggestion" role="presentation" style="top: 8px;">${item}</span>`
            );
          } else {
            $('.snize-input-style').after(
              `<span class="currentSuggestion" role="presentation" style="top: -21px;">${item}</span>`
            );

            $('.currentSuggestion').animate({ top: '8px' }, 500);
          }

          setTimeout(function () {
            $('.currentSuggestion').animate({ top: '40px' }, 500, function () {
              $(this).remove();

              index++;

              if (index >= inputSuggestions.length) {
                index = 0;
                firstIteration = false;
              }

              showSuggestion();
            });
          }, 2500);
        }

        showSuggestion();
      }, 100);
    }
  })(window.Searchanise.$);
});


